import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Button } from "react-bootstrap";

const ExportPDF = ({
  studentList,
  subjectList,
  type,
  examName,
  standardLabel,
  divisionLabel,
  filename = "Exam_Wise_Report.pdf",
}) => {
  const downloadPDF = () => {
    const doc = new jsPDF("l", "mm", "a4");

    // ---------------- TITLE ----------------
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("Exam Wise Report", 14, 15);

    // ---------------- META INFO ----------------
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    const metaY = 22;
    doc.text(`Class: ${standardLabel}`, 14, metaY);
    doc.text(`Section: ${divisionLabel}`, 80, metaY);

    doc.text(`Exam Type: ${type}`, 14, metaY + 6);
    doc.text(`Exam Name: ${examName}`, 80, metaY + 6);

    // ---------------- TABLE HEADERS ----------------
    let head = [];
    let body = [];

    if (type === "Internal Assessment") {
      const headerRow1 = [
        { content: "NAME", rowSpan: 2 },
        { content: "ROLL No.", rowSpan: 2 },
        { content: "ADMISSION No.", rowSpan: 2 },
        ...subjectList.map((s) => ({
          content: s.Name,
          colSpan: 5,
          styles: { halign: "center" },
        })),
      ];

      const headerRow2 = subjectList.flatMap(() => [
        "CLASS WORK",
        "HOME WORK",
        "SUB ENRICHMENT",
        "DISCIPLINE",
        "CLASS INVOLVEMENT",
      ]);

      head = [headerRow1, headerRow2];
    } else {
      head = [
        [
          "NAME",
          "ROLL No.",
          "ADMISSION No.",
          ...subjectList.map((s) => s.Name),
        ],
      ];
    }

    // ---------------- TABLE BODY ----------------
    studentList.forEach((s) => {
      let row = [s.name, s.roll, s.admission];

      if (type === "Internal Assessment") {
        s.classWork.forEach((_, i) => {
          row.push(
            s.classWork[i],
            s.homeWork[i],
            s.subEnrichment[i],
            s.discipline[i],
            s.classInvolvement[i]
          );
        });
      } else {
        s.marks.forEach((m) => row.push(m));
      }

      body.push(row);
    });

    autoTable(doc, {
      startY: metaY + 14,
      head,
      body,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 2,
        halign: "center",
        valign: "middle",
      },
      headStyles: {
        fillColor: [52, 58, 64],
        textColor: 255,
        fontStyle: "bold",
      },
    });

    doc.save(filename);
  };

  return (
    <Button variant="danger" onClick={downloadPDF}>
      Export PDF
    </Button>
  );
};

export default ExportPDF;
